<template>
    <div>
        <!-- <section class="hero">
            <div class="owl-carousel owl-theme hero-slider" id="home-slider">
                <div v-for="(slider, i) in homeSliders" :key="i" :style="{backgroundImage: `linear-gradient(rgba(168, 199, 209, 0.35), rgba(168, 199, 209, 0.35)), url(${slider.image})`}"
                    class="item d-flex align-items-center"
                >
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="text-center overlay-text">
                                    <h1 :class="`header-text display-3 ${slider.text.color}`">
                                        {{ slider.text.header }}
                                    </h1>
                                    <h1 :class="`header-text display-2 ${slider.text.color}`">
                                        {{ slider.text.sub }}
                                    </h1>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->

        <div class="hero">
            <img :src="heroImg" alt="" class="img-fluid">
        </div>

        <div class="scroll-to-b pb-5" style="position: relative; margin-top: -100px; z-index: 5;">
            <div class="text-center">
                <div class="bounce arrow-down">
                    <img :src="arrowDown" alt="" height="40px;" @click="scrollTo()">
                </div>
            </div>
        </div>
        

        <!-- About -->
        <div class="container mt-5 pt-5" id="about-us-home">
            <div class="row position-relative add-pt-5">
                <div class="col-lg-3"></div>
                <div class="col-lg-9 d-none d-lg-block">
                    <div class="home-about" :style="{backgroundImage: 'url('+ aboutImg +')'}">
                    </div>
                </div>
                <div style="position: absolute;z-index:2;top:8%;width:500px;" class="d-none d-lg-block">
                    <div class="card" style="box-shadow: 0px 3px 7px rgba(0,0,0,0.10);border-radius: 0;">
                        <div class="card-body">
                            <small class="primary-color">WHAT WE DO</small>
                            <h2 class="primary-color header-text">About M&O law firm</h2>

                            <p>
                                Do you hate it when your lawyer does not understand your business or is simply unreachable? At M&O we aim to do better by building relationships with our clients and making ourselves available to our clients 24 hours a day.
                            </p>
                            <p>
                                We also try to understand our clients' business in order to give relevant and timely business advice. Contact us for a  free consultation.
                            </p>

                            <div class="mt-4 primary-btn">
                                <router-link to="/about-us" class="btn btn-primary px-5">
                                    KNOW MORE
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-12 d-lg-none">
                    <div class="card" style="box-shadow: 0px 3px 7px rgba(0,0,0,0.10);border-radius: 0;">
                        <div class="card-body">
                            <small class="primary-color">WHAT WE DO</small>
                            <h2 class="primary-color header-text">About M&O law firm</h2>

                            <p>
                                Do you hate it when your lawyer does not understand your business or is simply unreachable? At M&O we aim to do better by building relationships with our clients and making ourselves available to our clients 24 hours a day.
                            </p>
                            <p>
                                We also try to understand our clients' business in order to give relevant and timely business advice. Contact us for a free consultation.
                            </p>

                            <div class="mt-4 primary-btn">
                                <router-link to="/about-us" class="btn btn-primary px-5">
                                    KNOW MORE
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Why choose -->
        <div class="home-why-choose py-5 mt-5" :style="{backgroundImage: `url(${homeWhyChoose})`}">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 text-center mb-3">
                        <small class="primary-color">WHY CHOOSE US</small>
                        <h2 class="header-text primary-color">Reasons we are the best for you</h2>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <div class="card">
                            <div class="card-body text-center">
                                <div class="mb-4">
                                    <img :src="intergrity" alt="" height="70px">
                                </div>

                                <h3 class="primary-color header-text-regular">Awesome Relationship</h3>
                                <p>We focus on building awesome relationships with our clients.</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <div class="card">
                            <div class="card-body text-center">
                                <div class="mb-4">
                                    <img :src="empathy" alt="" height="70px">
                                </div>

                                <h3 class="primary-color header-text-regular">Total Empathy</h3>
                                <p>We make an effort to understand our client’s needs.</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <div class="card">
                            <div class="card-body text-center">
                                <div class="mb-4">
                                    <img :src="support" alt="" height="70px">
                                </div>

                                <h3 class="primary-color header-text-regular">24/7 Support</h3>
                                <p>We provide 24/7 support to our clients and this includes on weekends and public holidays.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Practices -->
        <div class="my-5 practicess">
             <div class="pb-5">
                 <div class="text-center mb-5">
                     <small class="primary-color">HOW CAN WE HELP YOU</small>
                     <h2 class="primary-color header-text">Practice Areas</h2>
                 </div>
                 <div class="">
                     <div id="masonry-container" class="cbp cbp-l-grid-masonry-projects">
                         <practice-component
                            v-for="(practice, i) in practices" :key="i"
                            :name="practice.name"
                            :dash="practice.dash"
                            :mask="practice.mask"
                            :image="practice.image"
                         ></practice-component>
                     </div>

                 </div>
             </div>
         </div>


         <!-- Articles -->
         <div class="home-articles py-5" :style="{backgroundImage: 'linear-gradient(rgba(0, 65, 107, 0.68), rgba(0, 65, 107, 0.68)),url('+homeArticlesImage+')'}">

             <div class="container pt-5">
                 <div class="row">
                    <div class="col-md-3 mb-sm-4">
                        <router-link to="/articles" class="text-white">
                            <h1 class="header-text ">News & Articles</h1>
                        </router-link>
                        <!-- <small>KNOW WHAT IS GOING ON</small>
                        <span class="d-block view-all-anchor">
                            <router-link to="/articles" class="text-white">click for more</router-link>
                        </span> -->
                    </div>

                    <div class="col-md-9">
                        <div class="blog-slider articles-card">
                            <div class="blog-carousel owl-carousel owl-theme">

                                <div v-for="(article, i) in articles" :key="i">
                                    <article-card 
                                        :created_by="article.created_by"
                                        :date_created="article.date_created"
                                        :title="article.title"
                                        :content="wordLimiter(article.content, 6)"
                                        :mask="article.mask"
                                        :dash="article.dash"
                                        :date_link="article.date_link"
                                    />
                                </div>

                            </div>
                        </div>
                    </div>
                    
                </div>
             </div>
         </div>

        <!-- Consultation -->
        <div class="consultation">
            <div class="row no-gutters consult">
                <div class="col-md-6">
                    <div class="greetingsBg" :style="{backgroundImage: 'url('+greetingsImage+')'}"></div>
                </div>

                <div class="col-md-6">
                    <div class="left-contact left-bg px-7 py-7">
                        <div class="text-center text-white mb-4">
                            <small>DON’T HESITATE TO ASK</small>
                            <h1 class="header-text">Request a Free Consultation</h1>
                            <p>We are passionate about providing quality services, customized to each client’s individual needs.</p>
                        </div>
                        <contact-form purpose="free-consultation"></contact-form>
                    </div>
                </div>
            </div>
        </div>

        <!-- <consultation-modal></consultation-modal> -->
    </div>
</template>

<script>
let scrollToElement = require('scroll-to-element');
let cbp = require('@/assets/css/cubeportfolio.min.css');
let owlCss = require('@/assets/css/owl.carousel.min.css');
let owlTheme = require('@/assets/css/owl.theme.default.min.css');
let greetingsImage = require('@/assets/img/about/greetings.jpg');
let homeArticlesImage = require('@/assets/img/home-aricles.jpg');
let homeWhyChoose = require('@/assets/img/lam.png');
let aboutImg = require('@/assets/img/about/about1.jpg');

let heroImg = require('@/assets/img/moconsult.jpg');

let slider1 = require('@/assets/img/sliders/slider1.jpg');
let slider2 = require('@/assets/img/sliders/slider2.jpg');

let homeSliders = [
    {
        image: slider1,
        text: {
            header: 'Is it About a Land Dispute?',
            sub: 'We Can Help',
            color: 'primary-color'
        }
    },
    {
        image: slider2,
        text: {
            header: 'Is it About a Land Dispute?',
            sub: 'We Can Help',
            color: 'text-transparent'
        }
    }
];

//Icons
let intergrity = require('@/assets/icons/integrity.svg');
let empathy = require('@/assets/icons/courage.svg');
let support = require('@/assets/icons/proactive.svg');
let arrowDown = require('@/assets/icons/arrow-down.svg');

import axios from 'axios';
import {
    practicesOptions,
    articlesSliderOptions,
    heroSliderOptions
} from '@/assets/js/exports.js';
import PracticeComponent from '@/components/frontend/PracticeComponent.vue';
import ContactForm from '@/components/ContactForm.vue';
import ArticleCard from '@/components/frontend/articles/Articles.vue';
import ConsultationModal from '@/components/frontend/ConsultationModal.vue';

export default {
    components: {
        PracticeComponent: PracticeComponent,
        ContactForm: ContactForm,
        ArticleCard: ArticleCard,
        ConsultationModal: ConsultationModal
    },
    name: 'Home',
    data() {
        return {
            heroImg,
            homeSliders: homeSliders,
            practices: [],
            articles: [],
            about: '',
            title: 'Home',
            greetingsImage: greetingsImage,
            homeArticlesImage: homeArticlesImage,
            aboutImg: aboutImg,
            homeWhyChoose: homeWhyChoose,
            intergrity: intergrity,
            empathy: empathy,
            support: support,
            arrowDown: arrowDown
        };
    },
    metaInfo() {
        return {
            title: this.title,
            link: [
                { rel: 'stylesheet', href: cbp },
                { rel: 'stylesheet', href: owlCss },
                { rel: 'stylesheet', href: owlTheme }
            ]
        };
    },
    methods: {
        fetchPractices() {
            axios
                .get(APIURL + 'practices')
                .then(response => {
                    this.practices = response.data;

                    this.$nextTick(function() {
                        $('#masonry-container').cubeportfolio(practicesOptions);
                    });
                })
                .catch(err => {
                    console.log(err);
                });
        },

        wordLimiter(word, limit) {
            let arr = word
                .split(' ')
                .splice(0, limit)
                .join(' ');
            return arr + '...';
        },

        // Recent articles
        fetchArticles() {
            let self = this;

            axios
                .get(APIURL + 'articles/recent')
                .then(response => {
                    let res = response.data;
                    this.articles = res.data;

                    this.$nextTick(() => {
                        $('.blog-carousel').owlCarousel(articlesSliderOptions);
                    });
                })
                .catch(err => {
                    console.log(err);
                });
        },

        fetchAboutData() {
            axios
                .get(APIURL + 'about')
                .then(response => {
                    let res = response.data;
                    this.about = res.about.content;
                })
                .catch(err => {
                    console.log(err);
                });
        },

        scrollTo() {
            // with options
            let elem = document.querySelector('#about-us-home');
            let elem2 = document.querySelector('.add-pt-5');
            elem2.classList.add('pt-5');
            scrollToElement(elem, {
                offset: 0,
                ease: 'linear',
                duration: 1000
            });
        }

        // showModal() {
        //     setTimeout(() => {
        //         $('#consultationModal').modal('show');
        //     }, 2000);
        // }
    },
    created() {
        this.fetchPractices();
        this.fetchArticles();
        this.fetchAboutData();

        this.$nextTick(() => {
            $('#home-slider').owlCarousel(heroSliderOptions);
        });

        //this.showModal();
    }
};
</script>



// WEBPACK FOOTER //
// src/views/frontend/Home.vue